module.exports = __webpack_public_path__ + "media/images/shared/icon_slider_prev-ca42e4a1111c08889f5f9a56374a71f6.png";